export default "__VITE_ASSET__e8eff221__"